import React from 'react';
import { MessageSquare } from 'lucide-react';
import { personalInfo } from '../data/mock';

export default function WhatsAppFloat() {
  const msg = encodeURIComponent('Halo Erwin, saya ingin berkonsultasi mengenai kebutuhan IT saya.');
  const url = `https://wa.me/${personalInfo.whatsapp}?text=${msg}`;

  return (
    <a href={url} target='_blank' rel='noreferrer'
      data-hover='true'
      style={{
        position: 'fixed', bottom: 28, right: 28, zIndex: 999,
        width: 56, height: 56, borderRadius: '50%',
        background: '#25D366',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        textDecoration: 'none', color: '#fff',
        boxShadow: '0 4px 24px rgba(37,211,102,0.45)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        cursor: 'none',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'scale(1.12)';
        e.currentTarget.style.boxShadow = '0 8px 32px rgba(37,211,102,0.65)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 24px rgba(37,211,102,0.45)';
      }}
    >
      {/* Pulse ring */}
      <div style={{
        position: 'absolute', inset: -4, borderRadius: '50%',
        border: '2px solid rgba(37,211,102,0.4)',
        animation: 'float 2s ease-in-out infinite',
        pointerEvents: 'none',
      }} />
      <MessageSquare size={24} fill='white' />
    </a>
  );
}
